import { useEffect } from 'react';
import { CardConfig } from '../constants/cards.ts';

interface MetaTagsProps {
  cardConfig: CardConfig;
}

const MetaTags: React.FC<MetaTagsProps> = ({ cardConfig }) => {
  useEffect(() => {
    const { eventType, weddingDateDisplay, weddingTime, sharedDetails } = cardConfig;
    
    // Update document title
    document.title = `${sharedDetails.groomName} & ${sharedDetails.brideName} - ${eventType}`;
    
    // Update meta description
    const description = `${weddingDateDisplay} | ${weddingTime} | ${sharedDetails.venueName}`;
    updateMetaTag('name', 'description', description);
    
    // Update Open Graph tags
    const title = `${eventType} - ${sharedDetails.groomName} & ${sharedDetails.brideName}`;
    updateMetaTag('property', 'og:title', title);
    updateMetaTag('property', 'og:description', description);
    updateMetaTag('property', 'og:site_name', title);
    
    // Update Twitter tags
    updateMetaTag('name', 'twitter:title', title);
    updateMetaTag('name', 'twitter:description', description);
    
  }, [cardConfig]);

  return null; // This component doesn't render anything
};

// Helper function to update or create meta tags
function updateMetaTag(attribute: string, key: string, content: string) {
  let element = document.querySelector(`meta[${attribute}="${key}"]`);
  
  if (element) {
    element.setAttribute('content', content);
  } else {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    element.setAttribute('content', content);
    document.head.appendChild(element);
  }
}

export default MetaTags;

